import http from "../utils/http"

/**
 * ที่อยู่
 * @param {object} params
 */
export function getArea(params) {
    return http({
        url: "/api/address/lists",
        data: params
    })
}

/**
 * รับภูมิภาค
 */
export function getCity(params) {
    return http({
        url: "/api/address/city",
        data: params
    })
}
